import React from 'react';
import * as firebase from 'firebase';
import ReactFireComponent from '../react-fire-component/react-fire-component';
import './hall-selector.css';

/** @class HallSelector
  * A componet for selecting which halls a booth
  * should appear within.
  * @prop {string} expoID - the id of the expo that is being edited
  * @prop {string} boothID - the id of the booth that is being edited
  */
export default class HallSelector extends ReactFireComponent {
  /** @constructor
    * Constructs a new HallSelector for the specified booth
    */
  constructor(props) {
    super(props);
    this.hallURL = `expos/${this.props.expoID}/halls`;
    this.boothURL = `expos/${this.props.expoID}/booths/${this.props.boothID}`;
    this.dataRef = firebase.database().ref(`expos/${this.props.expoID}/halls`);
    this.state = {halls: []}
    this.handleChange = this.handleChange.bind(this);
  }
  /** @method componentWillMount
    * Binds the hall list to the Firebase database
    */
  componentWillMount() {
    this.bindAsArray(this.hallURL, 'halls');
  }
  /** @method componentWillUnmount
    * Unbinds the hall list from the Firebase database
    */
  componentWillUnmount() {
    this.unbind('halls')
  }
  /** @method componentWillReceiveProps
    * When the state of the booth changes,
    * this method also updates the duplicate
    * state (published, icon) of booth icons in the halls.
    */
  componentWillReceiveProps(newProps) {
    if(this.props.published !== newProps.published || this.props.icon !== newProps.icon) {
      var updates = {}
      this.state.halls.forEach(hall => {
        if(hall.booths && hall.booths[this.props.boothID]) {
          updates[`${this.hallURL}/${hall.id}/booths/${this.props.boothID}/published`] = newProps.published;
          updates[`${this.hallURL}/${hall.id}/booths/${this.props.boothID}/icon`] = newProps.icon;
        }
      });
      if(Object.values(updates).length > 0) firebase.database().ref().update(updates);
    }
  }
  /** @method handleChange
    * Adds or removes the booth from the specified hall.
    */
  handleChange(event) {
    if(!this.props.icon) return alert("Booth must have an icon to be added to a hall.");
    var updates = {}
    var hallID = event.target.value;
    if(event.target.checked) {
      // Add the booth to the hall
      var hallData = {
        name: this.props.name,
        icon: this.props.icon,
        published: this.props.published,
        order: 9999, // Add to the end of the list
        width: 100,
        height: 100,
        x: 10,
        y: 10
      }
      updates[`${this.hallURL}/${hallID}/booths/${this.props.boothID}`] = hallData;
      updates[`${this.boothURL}/halls/${hallID}`] = true;
    } else {
      // Remove the booth from the hall
      updates[`${this.hallURL}/${hallID}/booths/${this.props.boothID}`] = null;
      updates[`${this.boothURL}/halls/${hallID}`] = null;
    }
    firebase.database().ref().update(updates);
  }
  /** @method render
    * Renders the add/remove booth to hall checkboxes.
    */
  render() {
    const hallCheckboxes = this.state.halls.map(hall => (
      <label htmlFor={`hall-${hall.id}`} key={hall.id}>
        <input id={`hall-${hall.id}`}
          type="checkbox"
          value={hall.id}
          checked={(hall.booths && hall.booths[this.props.boothID]) || false}
          onChange={this.handleChange}
        />
        {hall.metadata.name}
      </label>
    ));
    return (
      <div className="hall-selector">
        <label>Included in Halls</label>
        <div className="hall-selections">
          {hallCheckboxes}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/booth-editor/hall-selector.js